var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 1000,
    width: 1500,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.026540582226772358 0.7329999999999899 354.2665294165214 353.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M305.721 5.315H48.494A44.26 44.26 0 0 0 4.68 49.74V305.83a44.258 44.258 0 0 0 43.815 44.426h257.227a44.147 44.147 0 0 0 43.843-44.426V49.658A44.145 44.145 0 0 0 305.721 5.23",
    fill: "#9f1a45",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M305.721 354.671H48.494A48.702 48.702 0 0 1 .097 305.774V49.658A48.702 48.702 0 0 1 48.494.733H305.72a48.703 48.703 0 0 1 48.397 48.925v256.088a48.702 48.702 0 0 1-48.397 48.897M48.494 9.869A39.567 39.567 0 0 0 9.232 49.658v256.088a39.57 39.57 0 0 0 39.262 39.79H305.72a39.57 39.57 0 0 0 39.262-39.79V49.658a39.599 39.599 0 0 0-39.262-39.79z",
    fill: "#9f1a45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M179.249 76.654a53.228 53.228 0 1 1-54.061 53.229 53.604 53.604 0 0 1 15.99-37.828 53.592 53.592 0 0 1 38.071-15.4zm62.558-26.294h62.807V305.17h-62.835v-72.192c-55.31 20.214-107.011 21.991-154.575-24.546-19.659-20.463-30.737-48.368-26.1-97.015.805-7.441-2.777-41.955-11.44-61.086h55.672c26.128 41.483-8.136 94.405 31.903 128.225 54.533 35.319 102.125-6.914 104.429-45.037z",
    fill: "#febd30",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPnb);
export default __webpack_public_path__ + "static/media/pnb.6fff6553e70ca3f4a6e5783548a08922.svg";
export { ForwardRef as ReactComponent };